<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['ADDUSERTOGROUPROLE'] | translate}}</h4>
    </div>
    <div class="card-body">
        <form [formGroup]="userGroupRoleForm">
            <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="roleId" readonly>
            </mat-form-field>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width" *ngIf="!_userSelected">
                        <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="userName" [matAutocomplete]="auto">

                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                            (optionSelected)="optionSelected($event)">
                            <mat-option *ngIf="isLoading" class="is-loading">
                                <mat-spinner diameter="50"></mat-spinner>
                            </mat-option>
                            <ng-container *ngIf="!isLoading">
                                <mat-option *ngFor="let user of userDtos" [value]="user">
                                    <span><b>{{ user.userName }}</b> - {{ user.email }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>
                    <a class="a-color" *ngIf="_userSelected && projectGroupRoleUser.userName != ''">{{projectGroupRoleUser.userName}}</a>
                    <!-- <a class="a-color" *ngIf="_userSelected && projectGroupRoleUser.userName == ''">{{user.email}}</a> -->
                </div>
            </div>
            <div class="row">
                <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button (click)="cancel()" >
                    <mat-icon>close</mat-icon>
                </button>
                <span style="flex: 1 1 auto"></span>
                <button matTooltip="{{this.translate.data['ADDTENANTPROJECTGROUPROLE'] | translate}}" mat-button (click)="add()">
                    <mat-icon>add</mat-icon>
                </button> -->
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >Abbruch</button>
                  </a>                                                
                  <span style="flex: 1 1 auto"></span>
                  <a>
                        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDUSERTOGROUPROLE'] | translate}}"
                                        (click)="add()" >Hinzufügen</button>
                  </a>                   
    
            </div>      
        </form>
    </div>
</div>

